import { jsPDF } from "jspdf";
import { CATEGORIES } from "@/lib/categories";

function fmtDate(iso) {
  try {
    return new Date(iso).toLocaleString("pt-PT", {
      day: "2-digit", month: "long", year: "numeric", hour: "2-digit", minute: "2-digit",
    });
  } catch { return iso || ""; }
}
function fmtDur(s) { return `${Math.floor((s || 0) / 60)}m ${(s || 0) % 60}s`; }

export function exportCallPdf(call) {
  const doc = new jsPDF({ unit: "pt", format: "a4" });
  const PAGE = 595, M = 48, W = PAGE - M * 2;
  let y = 118;

  doc.setFillColor(37, 99, 235);
  doc.rect(0, 0, PAGE, 92, "F");
  doc.setTextColor(255, 255, 255);
  doc.setFont("helvetica", "bold"); doc.setFontSize(22);
  doc.text("PitchPulse AI", M, 46);
  doc.setFont("helvetica", "normal"); doc.setFontSize(12);
  doc.text("Relatório de Chamada", M, 68);

  doc.setTextColor(15, 23, 42);
  const meta = [
    ["Lead / Cliente", call.lead_name || "—"],
    ["Data", fmtDate(call.created_at)],
    ["Plataforma", call.platform || "—"],
    ["Duração", fmtDur(call.duration_seconds)],
    ["Comercial", call.user_name || "—"],
    ["Objeções", `${call.objections_count ?? (call.objections || []).length} (superadas: ${call.resolved_count ?? 0})`],
  ];
  doc.setFontSize(11);
  meta.forEach(([k, v]) => {
    doc.setFont("helvetica", "bold"); doc.text(`${k}:`, M, y);
    doc.setFont("helvetica", "normal"); doc.text(String(v), M + 120, y);
    y += 20;
  });

  y += 10;
  doc.setFont("helvetica", "bold"); doc.setFontSize(14);
  doc.text("Objeções encontradas", M, y); y += 20;
  doc.setFontSize(11);
  (call.objections || []).forEach((o) => {
    const cat = CATEGORIES[o.category]?.label || o.category;
    const status = o.resolved ? "superada" : "não superada";
    const line = doc.splitTextToSize(`• [${cat}] ${o.text} — ${status}`, W);
    if (y > 760) { doc.addPage(); y = 60; }
    doc.setFont("helvetica", "normal");
    doc.setTextColor(o.resolved ? 16 : 100, o.resolved ? 185 : 116, o.resolved ? 129 : 139);
    doc.text(line, M, y); y += line.length * 15 + 4;
  });

  if (call.summary) {
    y += 12; if (y > 720) { doc.addPage(); y = 60; }
    doc.setTextColor(15, 23, 42);
    doc.setFont("helvetica", "bold"); doc.setFontSize(14);
    doc.text("Resumo & Próximos Passos", M, y); y += 20;
    doc.setFont("helvetica", "normal"); doc.setFontSize(11);
    const sum = doc.splitTextToSize(call.summary, W);
    sum.forEach((ln) => { if (y > 780) { doc.addPage(); y = 60; } doc.text(ln, M, y); y += 16; });
  }

  const safe = (call.lead_name || "chamada").replace(/[^\w\-]+/g, "_");
  doc.save(`PitchPulse_${safe}.pdf`);
}
